module.exports = __webpack_public_path__ + "static/media/bf12.09cf56ea.png";